import { GenerationMethod } from '@heidi/schema/ml-scribe';

export type SideBySideMethodClass = 'template' | 'auto' | 'none';

export function classifySideBySideMethod(
  method: GenerationMethod | undefined
): SideBySideMethodClass {
  switch (method) {
    case GenerationMethod.TEMPLATE:
    case GenerationMethod.INTERNAL_TEMPLATE:
      return 'template';
    case GenerationMethod.AUTO_MODE:
      return 'auto';
    default:
      return 'none';
  }
}

export type SideBySideEligibilityInput = {
  methodClass: SideBySideMethodClass;
  isJsonTemplate: boolean;
  isSplitScreenActive: boolean;
  isLiveTranscriptionSplitView: boolean;
  isRegenerate: boolean;
  /** IS_SIDE_BY_SIDE_NOTE_GEN_ENABLED(), resolved by the caller. */
  broadExperimentEnabled: boolean;
  /** IS_SIDE_BY_SIDE_NOTE_PREFERENCE_TREATMENT(), resolved by the caller. */
  preferenceTreatment: boolean;
};

export function shouldAttemptSideBySide(i: SideBySideEligibilityInput): boolean {
  const broad = i.broadExperimentEnabled && i.methodClass === 'template';
  const preference = i.preferenceTreatment && i.methodClass !== 'none';
  return (
    !i.isJsonTemplate &&
    (broad || preference) &&
    !i.isSplitScreenActive &&
    !i.isLiveTranscriptionSplitView &&
    !i.isRegenerate
  );
}
